import { Icon } from '~/components/ui';
import { useT } from '~/i18n';
import { EU_WORK_AUTHORIZATIONS, type EuWorkAuthorization } from '../lib/immigration';

/**
 * «¿Puedes trabajar legalmente en la Unión Europea?»: las tres respuestas como
 * tarjetas que se eligen con un toque, con el mismo dibujo que H2StatusPicker.
 * Controlado: lo usan el paso del alta, la tarjeta de países del panel y la de
 * Preferencias, y cada uno guarda a su manera.
 */
interface Props {
  value: EuWorkAuthorization | null;
  onChange: (value: EuWorkAuthorization) => void;
  disabled?: boolean;
  /** Muestra la pregunta como título del grupo (el alta); la tarjeta la trae en su encabezado. */
  showQuestion?: boolean;
}

export default function EuAuthorizationPicker({ value, onChange, disabled, showQuestion }: Props) {
  const t = useT('onboarding').immigration.eu;

  return (
    <div className="space-y-2">
      {showQuestion && <p className="font-medium text-sm text-left">{t.question}</p>}
      <div role="radiogroup" aria-label={t.groupLabel} className="space-y-2">
        {EU_WORK_AUTHORIZATIONS.map((option) => {
          const selected = value === option;
          return (
            <button
              key={option}
              type="button"
              role="radio"
              aria-checked={selected}
              disabled={disabled}
              onClick={() => onChange(option)}
              className="w-full text-left p-3 flex items-start gap-3"
              style={{
                borderRadius: 'var(--r-inner)',
                border: `1px solid ${selected ? 'var(--hairline-hi)' : 'var(--hairline)'}`,
                background: selected ? 'var(--surface-hi)' : 'transparent',
              }}
            >
              <span
                className="grid place-items-center shrink-0 mt-0.5"
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: 999,
                  border: `1px solid ${selected ? 'transparent' : 'var(--hairline)'}`,
                  background: selected ? 'var(--purple-cta)' : 'transparent',
                  color: '#fff',
                }}
              >
                {selected && <Icon name="check" size={13} />}
              </span>
              <span className="min-w-0">
                <span className="block font-medium text-sm">{t.options[option].label}</span>
                {option === 'none' && <span className="block text-xs hush">{t.noneHint}</span>}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
